<template>
  <div ref="itemElement" class="item">
    <div class="graphic-wrapper">
      <div class="graphic">
        <div ref="solidElement" class="solid"></div>
        <icon
          ref="iconElement"
          class="icon"
          name="nomad:flame-2"
          size="2.4rem"
        />
      </div>
    </div>
    <div ref="labelElement" class="label">{{ label }}</div>
  </div>
</template>
<script setup lang="ts">
import { gsap } from 'gsap';

interface Props {
  label: string;
  unlocked: boolean;
}

const props = defineProps({
  label: null,
  unlocked: { type: Boolean }
});

const emit = defineEmits(["update"]);

const itemElement = ref();

const iconElement = ref(null);

const solidElement = ref(null);

const labelElement = ref(null);

const animation = ref();

const { width } = useElementBounding(itemElement);

watch(
  () => width.value,
  (val) => emit('update', val)
);

const getAnimation = () => {
  const tl = gsap.timeline({ delay: 0 });
  tl.fromTo(
    iconElement.value.$el,
    { rotate: 0, scale: 0 },
    { scale: 1, duration: 1.8, ease: 'elastic.out(1,0.2)' },
    0
  );
  tl.pause();
  return tl;
};

watch(
  () => props.unlocked && animation.value != null,
  (b) => {
    if (b) {
      animation.value.play();
    }
  }
);

onMounted(() => {
  animation.value = getAnimation();
});
</script>
<style lang="scss" scoped>
.graphic-wrapper,
.grapghic {
  display: flex;
  align-items: center;
  justify-content: center;
}
.graphic-wrapper {
  width: 4.2rem;
  height: 4.2rem;
}
.graphic {
  position: relative;
  width: 3rem;
  height: 3rem;

  .solid {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: var(--color_secondary_light);
  }
  .icon {
    position: relative;
    z-index: 1;
  }
}
.item {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
}
</style>
